<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
       
      </section>
      <!-- Main content -->
      <section class="content">
        <el-dialog
          title="Reset Password"
          customClass="customWidth"
          :visible.sync="dialogVisible"
          size="tiny"
          visible="false"
          :before-close="handleClose"
          v-show="showDialog"
        >
          <div class="account-box">
            <form role="form">
              <p class="instructionalText"  >
               Instructions on how to reset your password was sent to the following email: <br><strong>{{this.$route.params.email}}<br><br></strong><strong> If this email is associated with an account, you should receive an email shortly. </strong>

              </p>
                            
            </form>
            <hr />
            <div class="row-block">
              <div class="row"></div>
            </div>
          </div>
        </el-dialog>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
export default {
  beforeCreate(){
    //a temp way to navigate here ONLY by the forgotPassword page- needs to be changed.
    console.log("params", this.$route.params.email)
    if(!this.$route.params.email || !this.$route.params.email === undefined){
      this.$router.push('/404')
    }
  },
  data: function () {
    return {
      dialogVisible: false,
      showDialog: true,
      phoneChecked: "",
      emailChecked: "",
    };
  },
  methods: {
    handleClose: function (done) {
      this.showDialog = false;
      this.$router.push("/login");
      // this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
      //   confirmButtonText: 'OK',
      //   cancelButtonText: 'Cancel',
      //   type: 'warning'
      // })
    },
 
  
    

  },
};
</script>
<style scoped>
.instructionalText {
  font-weight: "bold";
  text-align: auto;
        font-size: 1.6vw;

}
.wrapper {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 1fr;
}

.options-alignment {
  padding-top: 50px;
  align-content: center;
}

.box1 {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 2;
  z-index: 2;
}

.box2 {
  grid-column-start: 3;
  grid-column-end: 4;

  grid-row-start: 1;
  grid-row-end: 2;
  z-index: 1;
}

.paragraph-font{
    font-size: 13pt;
      font-size: 1vw;

}
@media(max-width:450px){
  
.customWidth{
        width:90%;
        
    }
  
}
.customWidth{
        width:90%;
        
    }
@media(min-width:450px){
  
.customWidth{
        width:50%;
        
    }
  
}

.data-font{
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// PasswordReset.vue?0b58d8a0